import { Icon } from '@iconify/react'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { UserStatus, type User } from '../../types/ApiTypes'
import { MenuItem, MenuWrap } from '../styles/UserActionMenuStyle.ts'

export interface UserActionMenuProps {
  open: boolean
  onClose: () => void
  anchorRef: React.RefObject<HTMLElement | null>
  user?: User
  onViewDetails?: () => void
  onReviewKYC?: () => void
  onResetPassword?: () => void
  onBlockUser?: () => void
}

export default function UserActionMenu({ open, onClose, anchorRef, user, onViewDetails, onReviewKYC, onBlockUser }: UserActionMenuProps) {
  const wrapRef = useRef<HTMLDivElement | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    function handle(e: MouseEvent) {
      if (!open) return
      const t = e.target as Node
      if (wrapRef.current && !wrapRef.current.contains(t) && anchorRef.current && !anchorRef.current.contains(t)) {
        onClose()
      }
    }
    window.addEventListener('mousedown', handle)
    return () => window.removeEventListener('mousedown', handle)
  }, [open, onClose, anchorRef])

  if (!open) return null

  return (
    <MenuWrap ref={wrapRef} role="menu" aria-label="User actions">
      <MenuItem
        role="menuitem"
        onClick={() => {
          if (onViewDetails) onViewDetails(); else if (user) navigate(`/users/${user.id}`)
          onClose()
        }}
      >
        <Icon icon="solar:user-linear" width={20} />
        <span>User Details</span>
      </MenuItem>
      {user?.status === UserStatus.UNVERIFIED && (
        <MenuItem
          role="menuitem"
          onClick={() => {
            onReviewKYC?.()
            onClose()
          }}
        >
          <Icon icon="solar:shield-check-linear" width={20} />
          <span>Review KYC</span>
        </MenuItem>
      )}
      {user?.status === UserStatus.VERIFIED && (
        <MenuItem
          role="menuitem"
          className="danger"
          onClick={() => {
            onBlockUser?.()
            onClose()
          }}
        >
          <Icon icon="solar:forbidden-linear" width={20} />
          <span>Block User</span>
        </MenuItem>
      )}
      {user?.status === UserStatus.BLOCKED && (
        <MenuItem
          role="menuitem"
          onClick={() => {
            onBlockUser?.()
            onClose()
          }}
        >
          <Icon icon="solar:check-circle-linear" width={20} />
          <span>Unblock User</span>
        </MenuItem>
      )}
    </MenuWrap>
  )
}
